// extracted by mini-css-extract-plugin
module.exports = {"form":"UserPhotoForm_form__1tTYH","deleteButton":"UserPhotoForm_deleteButton__2fMIM","tooltip":"UserPhotoForm_tooltip__1uP0k"};